import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button } from "react-bootstrap";
import ReactJson from 'react-json-view'


const log = (type) => console.log.bind(console, type);



//This can be a file that the server references :)

var actionForms={



  "music":{
        schema:{
          title: "Play a file located in mp3 directory",
          type: "object",
          required: ["file"],
          properties: {
            cmd: {type: "string", title: "Play a file", value: "music"},
            file: {type: "string", title: "file path", default: "mp3/1.mp3"
          }
        }
      },
      uiSchema:{
        cmd: {"ui:widget": "hidden"}


          }
  },

  "dali":{
        schema:{
          title: "Send out a raw DALI command",
          type: "object",
          required: ["bus"],
          properties: {
            cmd: {type: "string", title: "command", value: "dali"},
            bus:{type: "number", title: "Dali BUS 0 or 1", default: 0},
            address: {type: "number", title: "Address", default: 0xFF},
            command: {type: "number", title: "Command", default: 0x05 }
        }
      },
      uiSchema:{
        cmd: {"ui:widget": "hidden"}


          }
  },
  "modbus":{
        schema:{
          title: "Send out a modbus frame",
          type: "object",
          required: ["address","code","data_addr","data_len"],
          properties: {
            cmd: {type: "string", title: "command", value: "modbus"},
            address: {type: "number", title: "Address", default: 0x02},
            code: {type: "number", title: "Function", default: 0x03 },
            data_addr:{type: "number", title: "Data address", default: 0x02},
            data_len:{type: "number", title: "Data length", default: 0x02},
        }
      },
      uiSchema:{
        cmd: {"ui:widget": "hidden"}
      }
  },


      "say":{
            schema:{
              title: "Say a phrase or variable over the speaker",
              type: "object",
              required: ["text"],
              properties: {
                cmd: {type: "string", title: "Say Text", value: "say"},
                text: {type: "string", title: "Say Text", default: "Text to say"},
                voice: {type: "string", title: "TTS voice", default: "Amy" ,
                    "enum": [
                    "Amy",
                    "Emma",
                    "Brian"
                  ]}
            }
          },
          uiSchema:{
            cmd: {"ui:widget": "hidden"}


              }
      },

      "delay":{
          schema:{
            title: "Delay the next action by a number of ms",
            type: "object",
            required: ["data"],
            properties: {
              cmd: {type: "string", title: "Say Text", value: "delay"},
              data: {type: "integer", title: "Number of ms", default: 5000},

          }

      },  uiSchema:{
      cmd: {"ui:widget": "hidden"}


        }
    },

    "buildString":{
        schema:{
          title: "Build a string from variables and strings, variable names will automatically be replaced by their value",
          type: "object",
          required: ["vars","saveVar"],
          properties: {
            cmd: {type: "string", title: "Say Text", value: "say"},
            vars: {title: "Strings", type: "array",
                  items: {
                      type: "string",
                      default: ""
                  }
                },
            join:   {type: "string", title: "How the above strings are joined, default is blank", default: ""},
            saveVar:{type: "string", title: "Variable Name to save this string too", default: "tempstr"},
        }
    } , uiSchema:{
    cmd: {"ui:widget": "hidden"}


      }
  },







  "buzzer":{
      schema:{
        title: "Sound the Buzzer",
        type: "object",
        required: ["count","ontime","offtime"],
        properties: {
          cmd: {type: "string", title: "Sound the Buzzer", value: "buzzer"},
          count: {type: "integer", title: "Number of Beeps", default: 1},
          ontime: {type: "integer", title: "On time", default: 100},
          offtime:{type: "integer", title: "Off time", default: 100},
      }

      },
        uiSchema:{
      cmd: {"ui:widget": "hidden"}
        }
  },


  "getimage":{
    schema:{
      title: "Capture still image from camera",
      type: "object",
      required: ["url"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "getimage"},
        url: {type: "string", title: "URL or variable to capture image", default: "http://"},

    }

    },

    uiSchema:{
  cmd: {"ui:widget": "hidden"},


    }


  },



  "485send":{
    schema:{
      title: "Send a message out of the 458 port",
      type: "object",
      required: ["data"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "485send"},
        data: {type: "string", title: "Text to send", default: "Text to send"},

    }

    },

    uiSchema:{
  cmd: {"ui:widget": "hidden"},
      data: {
        "ui:widget": "textarea"
      }


    }


  },


  "sendString":{
    schema:{
      title: "Send string to another altiom",
      type: "object",
      required: ["string","dest"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "sendString"},
        type:{type:"string", default:"remote485"},
        dest:{type:"string", title:"IP or variable name to Altiom",default:"PAGER_IP" },
        string: {type: "string", title: "string or name of variable to send (variable created by buildString)", default: "tempstr"},

    }

    },

    uiSchema:{
      cmd: {"ui:widget": "hidden"},
      data: {
        "ui:widget": "textarea"
      }


    }


  },


  "varCtrl":{
      schema:{
        title: "Manipulate Variables",
        type: "object",
        required: ["name","value","type"],
        properties: {
          cmd: {type: "string", title: "Sound the Buzzer", value: "vatCtrl"},
          name: {type: "string", title: "Name of variable", default: ""},
          value: {type: "string", title: "Value", default: "100"},
          type: {type: "string", title: "Mode", default: "set" ,
              "enum": [
              "set",
              "increment"
            ]}
      }

      },
        uiSchema:{
      cmd: {"ui:widget": "hidden"}
        }
  },




  "macro":{
    schema:{
      title: "Run another created action",
      type: "object",
      required: ["data","type"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "macro"},
        type: {type: "string", title: "Operation", default: "run" ,
            "enum": [
            "run",
            "stop"
          ]},
        data: {type: "string", title: "Macro", default: "" ,
          "enum": [
            "loading"

          ],
          "enumNames": [
                "Foo"
            ]


        }


      },

    },
    uiSchema:{
  cmd: {"ui:widget": "hidden"}
    }
  },


  "event":{
    schema:{
      title: "Enable/Disable another action",
      type: "object",
      required: ["data","type"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "logic"},
        type: {type: "string", title: "Operation", default: "Enable" ,
            "enum": [
            "Enable",
            "Disable"
          ]},
        data: {type: "string", title: "Event", default: "" ,
          "enum": [
            "loading"
          ],
          "enumNames": [
                "Foo"
            ]
        }
      },

    },
    uiSchema:{
  cmd: {"ui:widget": "hidden"}
    }
  },


  "schedule":{
    schema:{
      title: "Enable/Disable schedule",
      type: "object",
      required: ["data","type"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "scheudle"},
        type: {type: "string", title: "Operation", default: "Enable" ,
            "enum": [
            "Enable",
            "Disable"
          ]},
        data: {type: "string", title: "Schedule", default: "" ,
          "enum": [
            "loading"
          ],
          "enumNames": [
                "Foo"
            ]
        }
      },

    },
    uiSchema:{
  cmd: {"ui:widget": "hidden"}
    }
  },

  "outputCtrl":{
    schema:{
      title: "Control an ON/OFF output",
      type: "object",
      required: ["type"],
      properties: {
        "cmd": {type: "string", title: "Cmd", value: "outputCtrl"},

        outputID: { title: "Select an Output", default: "" ,
          "enum": [
            "loading"
          ],
          "enumNames": [
                "loading"
            ]
      },
        type: {type: "string", title: "Operation", default: "on" ,
            "enum": [
            "on",
            "off",
            "toggle"
          ],"enumNames": [
            "On",
            "Off",
            "Toggle"
            ]


        },
      }
    },
    uiSchema:{
  cmd: {"ui:widget": "hidden"}
    }


  },



    "system":{
      schema:{
        title: "System commands",
        type: "object",
        required: ["string"],
        properties: {
          "cmd": {type: "string", title: "Cmd", value: "system"},

          string: { title: "Select opperation", default: "" ,
          "enum": [
          "Reboot",
          "Reset Events",
          "Check Alert Level",
          "Cycle Network"
        ],"enumNames": [
          "Reboot",
          "Reset Logic",
          "Check Alert Level",
          "Cycle Network"
          ]
        },

        }
      },
      uiSchema:{
    cmd: {"ui:widget": "hidden"}
      }


    },


"script":{
  schema:{
    title: "Run a custom python script",
    type: "object",
    required: ["cmd","name","thread"],
    properties: {
      cmd: {type: "string", title: "Cmd", value: "script"},
      name:{type: "string", title: "name of script (case sensitive)", default: "" },
      thread:{type: "boolean", title: "Run as seprate process", default: true}
    },
  },
  uiSchema:{
    cmd: {"ui:widget": "hidden"},
  }
},




"sipcall":{
  schema:{
    title: "Make a sip call via a local PBX",
    type: "object",
    required: ["cmd","pbx_ip","pi_ip","dst_ext","text","src_ext"],
    properties: {
      cmd: {type: "string", title: "Cmd", value: "sip_call"},
      pbx_ip:{type: "string", title: "IP of PBX", default: "PBX_IP" },
      pi_ip:{type: "string", title: "IP PBX interface", default: "PBX_INT_IP"},
      src_ext:{type: "string", title: "Source extension", default: "3099"},
      user:{type: "string", title: "username", default: ""},
      password:{type: "string", title: "Password", default: ""},
      dst_ext:{type: "string", title: "Destination extension", default: "3099"},
      text:{type: "string", title: "Text to say on end device", default: "EVENT_NAME"},
    },
  },
  uiSchema:{
    cmd: {"ui:widget": "hidden"},
  }
},


"log":{
  schema:{
    title: "Insert an entry into log",
    type: "object",
    required: ["cmd","name","string"],
    properties: {
      cmd: {type: "string", title: "Cmd", value: "log"},
      name:{type: "string", title: "Name to appear against log", default: "" },
      string:{type: "string", title: "String or VAR_NAME to add to log", default: ""}
    },
  },
  uiSchema:{
    cmd: {"ui:widget": "hidden"},
  }
},


"report":{
  schema:{
    title: "Send out the report type to desired email list",
    type: "object",
    required: ["cmd","report_name","list"],
    properties: {
      cmd: {type: "string", title: "Cmd", value: "report"},
      report_name:{type: "string", title: "Report Name (temperature)", default: "temperature"},
      list: {type: "string", title: "Contact List", default: "" ,
        "enum": [
          "loading"
        ],
        "enumNames": [
              "loading"
          ]
      },
    },
  },
  uiSchema:{
    cmd: {"ui:widget": "hidden"},
  }
},

  "alertlist":{
    schema:{
      title: "Send alerts to multiple people",
      type: "object",
      required: ["list","cmd","message"],
      properties: {
        cmd: {type: "string", title: "Cmd", value: "alertlist"},
        online:{type: "boolean", title: "", default: true},
        list: {type: "string", title: "Contact List", default: "" ,
          "enum": [
            "loading"
          ],
          "enumNames": [
                "loading"
            ]
        },
        message:{type: "string", title: "Message to send", default: "" }
      },
    },
    uiSchema:{
      cmd: {"ui:widget": "hidden"},
      online:{"ui:widget": "hidden"}
    }
  },



}





export default class ActionCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        advancedEdit:false
      };
    }
    componentWillMount() {
      console.log("Action CREATE")
      console.log(this.props.data)
      this.setState({data:this.props.data})
    //  actionForms.macro.schema.properties.data.enum=["TEST1","TEST2","TEST3"]

      actionForms.macro.schema.properties.data.enum=this.props.macrolist.enum
      actionForms.macro.schema.properties.data.enumNames=this.props.macrolist.enumNames

      actionForms.alertlist.schema.properties.list.enum=this.props.vars.enum
      actionForms.alertlist.schema.properties.list.enumNames=this.props.vars.enumNames

      actionForms.report.schema.properties.list.enum=this.props.vars.enum
      actionForms.report.schema.properties.list.enumNames=this.props.vars.enumNames


      actionForms.outputCtrl.schema.properties.outputID.enum=this.props.outputs.enum
      actionForms.outputCtrl.schema.properties.outputID.enumNames=this.props.outputs.enumNames

      actionForms.event.schema.properties.data.enum=this.props.events.enum
      actionForms.event.schema.properties.data.enumNames=this.props.events.enumNames


      actionForms.schedule.schema.properties.data.enum=this.props.schedule.enum
      actionForms.schedule.schema.properties.data.enumNames=this.props.schedule.enumNames



    }
    test=()=>{
      console.log("Running Test")
      console.log(this.state.data)
      this.props.sendmsg({cmd:"action",data:this.state.data})
    }

    printDebug=()=>{
        this.props.callback("submit",this.state.data)

    }

    submit =(d)=>{
          console.log(JSON.stringify(d.formData))
            this.props.callback("submit",this.state.data)
    }

    onChange=(d)=>{
      this.setState({data:d.formData})

    }

    jsonEdit=(d)=>{
      console.log("Edit")
      console.log(d)
      if(typeof(d.existing_value)!=typeof(d.new_value)){
        alert("The Type has changed this key was a "+typeof(d.existing_value))

      }

      this.setState({data:d.updated_src})
      console.log(this.state.data)
    }
    jsonAdd=(d)=>{
      console.log("Add")
      console.log(d)
    }

    jsonDelete=(d)=>{
      console.log("delete")
      console.log(d)
      if(d.name=="cmd"){
        alert("cmd is always required")
        return false
      }
    }

    goAdvanced=()=>{
      console.log("Change edit")
      this.setState({advancedEdit:!this.state.advancedEdit})
    }
    cancel=()=>{
      console.log("Cancel Action")
      this.props.callback("cancel",this.state.data)


    }

    transformErrors=(errors) =>{
        console.log(errors);
        var e = [];
          errors.map(error => {
            if (error.message !== "should be equal to one of the allowed values"){
                e.push(error)
            }
          });
          console.log(e);
          return e;
    }

    render(){

      const validForm=(this.state.data.cmd in actionForms)
      console.log("Action Form Edit")
      console.log(validForm)
      if(validForm==true && this.state.advancedEdit==false){
        return (<span>

          <Form schema={actionForms[this.state.data.cmd]["schema"]}
          uiSchema={actionForms[this.state.data.cmd]["uiSchema"]}
                formData={this.state.data}
                 onChange={this.onChange}
                 onSubmit={this.submit}
                transformErrors={this.transformErrors}
                 onError={log("errors")} >
                 <Button type="submit">Save</Button>
                 <Button type="button" onClick={this.test}>Test</Button>
                 <Button type="button" onClick={this.cancel}>Cancel</Button>
                    <Button className="pull-right" onClick={this.goAdvanced}>Advanced</Button>
                 </Form>
          </span>
        )
      }
      else{
        return (
              <div>
                  <h4>Advanced edit for `{this.state.data.cmd}`, displaying JSON</h4>
                  <div className="jsonPAD">
                  <ReactJson  theme="solarized"  name={false} src={this.state.data}  enableClipboard={false} displayObjectSize={false} displayDataTypes={false} onEdit={this.jsonEdit} onDelete={this.jsonDelete} onAdd={this.jsonAdd}/>
                  </div>
                  <Button onClick={this.printDebug}>Save</Button>
                  <Button type="button" onClick={this.test}>Test</Button>
                  <Button type="button" onClick={this.cancel}>Cancel</Button>
                   {validForm ? (<Button className="pull-right" onClick={this.goAdvanced}>Form view</Button>):(<span></span>)}

              </div>

        )

}





    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/ActionCreate.js